import React, { useContext, useEffect, useRef, useState } from 'react'
import styles from "./slide.module.css"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faCircle, faCircleNotch} from "@fortawesome/free-solid-svg-icons"
import Menu from './menu/Menu'
import { store } from '../state/state'
import { translate } from '../state/translate'

export default function Slide() {
    const [image, setImage] = useState(0)
    let timer = useRef()
    let lang = useContext(store).selectedLang

    const images = [
        {text: translate[lang].makeYouComfort, image: "/life.webp"},
        {text: translate[lang].timeAndResources, image: "/time.webp"},
        {text: translate[lang].newSolutions, image: "/team.webp"},
        {text: translate[lang].modernTools, image: "/business.webp"}
    ]

    const startTimer = () => {
        clearInterval(timer.current)
        timer.current = setInterval(() => {
            setImage(p => (p + 1) % images.length)
        }, 7000)
    }

    useEffect(() => {
        startTimer()
        return () => clearInterval(timer.current)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const changeImage = (index) => {
        setImage(index)
        // restart the countdown so a manually picked slide gets its full time
        startTimer()
    }

  return (
    <div className={styles['slide-conteiner']} id="home">
        <div className={styles['slide-header']}>
            <h2>{translate[lang].ourGoal}</h2>
            <p>{images[image].text}</p>
        </div>
        <div className={styles['slide-image']}>
            {/* All slides stay mounted, so every image is fetched up front and switching is a pure opacity crossfade */}
            {images.map((item, index) => (
                <div
                    key={item.image}
                    className={`${styles['slide-layer']} ${index === image ? styles['active'] : ''}`}
                    style={{backgroundImage: `url("${item.image}")`}}
                />
            ))}
            <div className={styles['background-gradient']}></div>
            <div className={styles['circles']}>
                {images.map((_, index) => index === image ?<div key={index} className={styles['circle']}> <FontAwesomeIcon icon={faCircle} /></div> : <div key={index} className={styles['circle']} onClick={() => changeImage(index)}><FontAwesomeIcon icon={faCircleNotch} /></div>)}
            </div>
        </div>
        <div className={styles['menu-icon-container']}><Menu/></div>
    </div>
  )
}
